// Library Imports
import { useState, useEffect } from "react";
import styled from "styled-components";
import { Button, Col, Form, Input, Row, Select, Space } from "antd";
// import { Option } from "antd/lib/mentions";
import { useDispatch, useSelector } from "react-redux";
// Local Imports
import { RootState } from "store";
import SelectWithIcon from "modules/Campaigns/Shared/SelectWithIcon";
// actions Imports
import { addNode, clearDropArea, addActionModal, editNode, setSelectedIfElsesAction } from "../../actions";
import { ControlNameEnum, ConditionEmails, IControls } from "../../interfaces";
import { findDropAreaData, getConditionEmails } from "../../utils";

const { Option } = Select;

type IConditionProps = {
  id: string;
  enableSaveButton: (value: boolean) => void;
};

const IfElseContent = (props: IConditionProps) => {
  const { id, enableSaveButton } = props;
  // Redux States
  const itemData = useSelector((state: RootState) => state.automation.workflow.flow[id]?.detail);
  const controls: IControls[] = useSelector((state: RootState) => state.automation.controls);
  const dropData = useSelector((state: RootState) => state.automation.workflow.dropArea);
  const modal = useSelector((state: RootState) => state.automation.modals.addAction);
  const emails: ConditionEmails[] = getConditionEmails(dropData.id || id);
  const actionModalVisible: boolean = useSelector((state: RootState) => state.automation.modals.addAction.visible);
  const dispatch = useDispatch();

  let conditionControls = controls
    .find((control: IControls) => control.name === ControlNameEnum.IF_ELSE)
    ?.conditions?.map((condition) => {
      return {
        id: condition.id,
        value: condition.name,
        label: condition.name,
      };
    }) || [{ id: "", value: "", label: "" }];

  //local state
  const [selectedCondition, setSelectedCondition] = useState(conditionControls[0]);
  const [selectedEmail, setSelectedEmail] = useState("");

  const onEmailChange = (value: any) => {
    setSelectedEmail(value);
    enableSaveButton(value);
  };

  const selectHandler = (value: any) => {
    setSelectedCondition(value);
  };

  // useEffect to set the data of edit Node
  const isConditionModalOpen = modal.visible === true && modal.tab === ControlNameEnum.IF_ELSE;
  let dependencies = itemData && isConditionModalOpen;
  useEffect(() => {
    if (isConditionModalOpen && itemData) {
      if (itemData.hasOwnProperty("emailId")) {
        setSelectedEmail(itemData.emailId);
        setSelectedCondition({
          id: itemData.controlId,
          value: itemData.controlName,
          label: itemData.controlName,
        });
        enableSaveButton(true);
      }
    } else if (isConditionModalOpen && selectedEmail !== "") {
      setSelectedEmail("");
      setSelectedCondition(conditionControls[0]);
      enableSaveButton(false);
    }
  }, [dependencies]);

  useEffect(() => {
    if (modal.visible === false && selectedEmail !== "") {
      setSelectedEmail("");
      setSelectedCondition(conditionControls[0]);
      enableSaveButton(false);
    }
  }, [modal]);

  const submitHandler = (event: any) => {
    event.preventDefault();
    let email = emails.find((email) => email.emailId === parseInt(selectedEmail));
    let obj = findDropAreaData(ControlNameEnum.IF_ELSE);
    let title = `: ${email?.title}`;
    let conditionTime = "5m";
    if (id) {
      // edit Node
      dispatch(
        editNode(id, {
          ...itemData,
          controlName: selectedCondition?.value,
          controlId: selectedCondition?.id,
          emailId: email?.emailId,
          nodeTitle: title,
          conditionTime,
        })
      );
    } else {
      dispatch(
        addNode({
          ...obj,
          controlName: selectedCondition?.value,
          controlId: selectedCondition?.id,
          emailId: email?.emailId,
          nodeTitle: title,
          conditionTime,
        })
      );
    }
    enableSaveButton(false);
    dispatch(addActionModal(false));
    dispatch(clearDropArea());
  };

  useEffect(() => {
    if (selectedCondition && selectedEmail) {
      setSelectedIfElsesAction(parseInt(selectedCondition.id.toString()), parseInt(selectedEmail));
    } else {
      setSelectedIfElsesAction(0, 0);
    }
  }, [selectedCondition, selectedEmail]);

  useEffect(() => {
    if (!actionModalVisible) {
      setSelectedIfElsesAction(0, 0);
    }
  }, [actionModalVisible]);

  return (
    <Wrapper>
      <div className="label-model">If / Else</div>
      <div className="condition-wrapper">
        <div className="label-condition">Select a condition</div>
        <form id={`${ControlNameEnum.IF_ELSE}`} onSubmit={submitHandler}>
          <Row gutter={[32, 0]}>
            <Col span={12}>
              <SelectWithIcon
                defaultValue={{ value: "Select a condition", label: "Select a condition" }}
                options={conditionControls}
                onChange={selectHandler}
                value={selectedCondition}
                className="if-else-dropdown"
                menuWidth={267}
              />
            </Col>
            <Col span={12}>
              <Select
                className="condition-dropdown w-100"
                showSearch
                placeholder="Please select email"
                optionFilterProp="children"
                onChange={onEmailChange}
                allowClear
                value={emails.find((email) => email.emailId === parseInt(selectedEmail))?.title}
                // onClear={handleOnClear}
                filterOption={(input, option) =>
                  (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                }
                defaultActiveFirstOption={false}
              // open={true}
              // popupClassName="conditions-list"
              >
                {emails?.map((email: ConditionEmails) => {
                  let eId = `${email.emailId}`;
                  if (email.emailId) {
                    return (
                      <Option className="automation-dropdown-option" key={eId} value={eId}>
                        {email.title}
                      </Option>
                    );
                  }
                })}
              </Select>
            </Col>
          </Row>
        </form>
        {/* Hiding this for now */}
        {/* <div className="add-condition">
          <img src={AddIcon} alt="" /> Add another condition
        </div> */}
      </div>
    </Wrapper>
  );
};

export default IfElseContent;

const Wrapper = styled.div``;
